import { TaxResponseDocument } from './tax-response-document.model';
import { TaxResponseGroup } from './tax-response-group.model';

export class TaxResponseRecord {
    id = -1;
    inputField = -1;
    nestedGroups?: TaxResponseGroup[];
    dependsOnGroup?: number;
    data?: string | number | boolean;
    documents?: TaxResponseDocument[];

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.inputField = data.input_field ?? -1;
        this.nestedGroups =
            data.nested_groups != null ? data.nested_groups.map((gr: any) => new TaxResponseGroup().deserialize(gr)) : undefined;
        this.dependsOnGroup = data.depends_on_group ?? undefined;
        this.documents = data.documents != null ? data.documents.map((doc: any) => new TaxResponseDocument().deserialize(doc)) : undefined;
        this.data = data.data ?? undefined;
        return this;
    }

    serialize(): Record<string, any> {
        return {
            'input_field': this.inputField,
            'nested_groups': this.nestedGroups?.map((group) => group.serialize()),
            'depends_on_group': this.dependsOnGroup,
            data: this.data ?? null,
        };
    }
}
